/*
 * Loloi Google Shopping Search
 *
 **/

custom.googleShoppingSearch = (() => {
  const formClass = 'js-google-shopping-form';
  const btnClass = 'js-google-shopping-btn';
  const initClass = 'js-google-shopping-initialized';

  function searchHandler(event = null) {
    event.preventDefault();
    const word = $(event.target).hasClass(btnClass)
      ? $(event.target).data('query')
      : $(event.target).find('input[type="text"]').val();

    // window.open(`http://google.com/search?q=Loloi+${word}&tbm=shop`, "_blank");
    window.open(`https://google.com/search?q=Loloi+${word}`, '_blank');
  }

  const init = () => {
    if (!$(`.${btnClass}`).length) return;

    $(`.${btnClass}`).each((index, btn) => {
      if ($(btn).hasClass(initClass)) return;

      // Attach handler to events
      $(btn).closest(`.${formClass}`).on('submit', searchHandler);
      $(btn).on('click', searchHandler);

      $(btn).addClass(initClass);
    });
  };

  return {
    init,
  };
})();



// WEBPACK FOOTER //
// ./src/scripts/src/custom/google-shopping-search.js